import axios from "@/lib/axios";

export type SubmitQuizRequestParams = {
  companyId: string;
  quizId: string;
};

export type SubmitQuizResponse = void;

export const submitQuiz = (params: SubmitQuizRequestParams) =>
  axios
    .post<SubmitQuizResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.quizId}/submit`,
    )
    .then((r) => r.data);
